import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import TellyChannelLogo from '../../../images/app-store-icon.png';
import * as ModalActions from '../../../stores/actions/modal';
import { OpenTokContext } from '../../../contexts/opentok/opentok-context';

export default function OnsiteFeed(): JSX.Element {
	const dispatch = useDispatch();
	const { opentok } = useContext(OpenTokContext);

	const closeModal = () => {
		// opentok tries to start audio contexts for subscribers
		// these contexts need to resume after making a gesture
		// https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API/Best_practices#autoplay_policy
		if (opentok?.subscribers) {
			Object.entries(opentok?.subscribers).forEach(([, subscriber]) => {
				subscriber._.unblockAudio();
			});
		}
		dispatch(ModalActions.setModalOpen(false));
	};

	return (
		<div className="info-modal program-feed-modal">
			<div className="title-container">
				<div className="telly-channel-bubble">
					<img src={TellyChannelLogo} alt='telly'></img>
				</div>
				<span>View Onsite Program Feed</span>
			</div>

			<div className='body'>
				<span className="explanation">The Onsite Program Feed provides a low latency canvas ouput for live audiences to view. It does NOT output audio for users with “Onsite Program Feed” audio settings.</span>
				<br></br>
				<br></br>
				<a className='learn-more' href='https://help.brand.live/hc/en-us/articles/7903265877271'>Learn more about Greenroom’s Onsite Program Feed</a>
			</div>

			<div className='footer'>
				<button className='view-btn' data-testid="program-feed-modal-view-button" onClick={() => closeModal()}>View</button>
			</div>
		</div>
	);
}
